package components.tableCard

import csstype.Float
import csstype.Length
import csstype.px
import mui.material.Card
import mui.material.CardContent
import mui.material.Typography
import mui.material.styles.TypographyVariant
import mui.system.sx
import react.FC

val TableCard = FC<TableCardProps>("TableCard") { props ->
    Card {
        CardContent {
            sx {
                paddingTop = 6.px
            }

            Typography {
                variant = TypographyVariant.h6
                sx {
                    float = Float.left
                    width = Length.fitContent
                    marginTop = 10.px
                }
                +props.title
            }
            +props.children
        }
    }
}